(function Processor($, Adzuki)
{
	"use strict";

	Adzuki.onload('HotelSheets/processor', function onload() {
		_redirect();
	});

	function _redirect() {
		var $processor = $('div.processor-content'),
			url_params = $processor.data('url-params'),
		    url        = Adzuki.base_uri + '/HotelSheets/' + $processor.data('complete-action') + '/' + url_params;

		window.location.href = url;
	}
}(jQuery, window.Adzuki || {}));
